
import { AdminUserDTOGenderEnum } from '@/models'
import { useAccountStore } from '@/store/auth/account.store'
import { useAuthStore } from '@/store/auth/auth.store'
import { useKycStore } from '@/store/auth/kyc.store'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Header',
  computed: {
    accountStore() {
      return useAccountStore()
    },
    authStore() {
      return useAuthStore()
    },
    kycStore() {
      return useKycStore()
    },
    kycInfo() {
      return this.kycStore.kycInfo
    },
    isKycVerified() {
      const status = this.kycInfo?.latestVerificationStatus?.toUpperCase()
      return status === 'VERIFIED' || status === 'APPROVED' || status === 'COMPLETED'
    }
  },
  data: () => ({
    drawer: false,
    loading: false,
    adminUserDTOGenderEnum: AdminUserDTOGenderEnum
  }),
  mounted() {
    // Charge le statut KYC une seule fois via le store Pinia
    const clientId = this.accountStore.accountData.address && this.accountStore.accountData.address.client ? this.accountStore.accountData.address.client.id : null
    if (clientId) {
      this.kycStore.fetchKycInfo(clientId, false)
    }
  },
  methods: {
    formatName: function () {
      let fullName = this.accountStore.accountData.firstName + ' ' + this.accountStore.accountData.lastName
      if (fullName.length > 18) {
        fullName = fullName.substring(0, 18) + '...'
      }
      return fullName
    },
    getKycStatusText(): string {
      const status = this.kycInfo?.latestVerificationStatus?.toUpperCase() || 'UNKNOWN'
      const statusMap: Record<string, string> = {
        VERIFIED: this.$t('statusVerified') as string,
        APPROVED: this.$t('statusApproved') as string,
        COMPLETED: this.$t('statusCompleted') as string,
        IN_PROGRESS: this.$t('statusInProgress') as string,
        PENDING: this.$t('statusPending') as string,
        SUBMITTED: this.$t('statusSubmitted') as string,
        RESUBMISSION_REQUESTED: this.$t('statusResubmissionRequested') as string,
        DECLINED: this.$t('statusDeclined') as string,
        EXPIRED: this.$t('statusExpired') as string,
        ABANDONED: this.$t('statusAbandoned') as string
      }
      return statusMap[status] || (this.$t('statusUnknown') as string)
    },
    logout: function () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.authStore.logout()
      }, 2000)
    }
  }
})
